import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

export default function getCategories() {
    return shop.get(getUrl(`/products/categories`)).json<ShopTypes.CategoryQueryResult>();
}
